import { Link } from 'react-router';

interface ContentCTAProps {
  heading?: string;
  subtext?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

/**
 * Reusable end-of-content call-to-action block used across content, use-case,
 * and alternatives pages. Gives every page a clear conversion path.
 */
export function ContentCTA({
  heading = 'Start collecting feedback in minutes',
  subtext = 'Add Pollenate to any site with one line of code. Free to start — no credit card required.',
  primaryLabel = 'Get started free',
  primaryTo = '/login',
  secondaryLabel = 'See pricing',
  secondaryTo = '/pricing',
}: ContentCTAProps) {
  return (
    <section className="px-4 sm:px-6 lg:px-8 py-14">
      <div className="max-w-4xl mx-auto rounded-2xl border border-amber-200/70 dark:border-amber-800/40 bg-gradient-to-br from-amber-50 to-orange-50 dark:from-amber-950/30 dark:to-orange-950/20 p-8 sm:p-12 text-center">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-white">
          {heading}
        </h2>
        <p className="mt-3 text-lg text-slate-600 dark:text-neutral-300 max-w-2xl mx-auto">
          {subtext}
        </p>
        <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to={primaryTo}
            className="inline-flex items-center justify-center rounded-lg bg-gradient-to-r from-amber-500 to-orange-500 px-6 py-3 text-base font-semibold text-white shadow-sm hover:from-amber-600 hover:to-orange-600 transition-colors"
          >
            {primaryLabel}
          </Link>
          <Link
            to={secondaryTo}
            className="inline-flex items-center justify-center rounded-lg border border-slate-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 px-6 py-3 text-base font-semibold text-slate-900 dark:text-white hover:bg-slate-50 dark:hover:bg-neutral-800 transition-colors"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
